import { SectionLabel } from '@reflex/ui/components/layout/Typography';
import { ProviderChip } from '@reflex/ui/components/agent/ProviderChip';
import { ModelChip } from '@reflex/ui/components/agent/ModelChip';
import { ModelDefaultOriginBadge } from './ModelDefaultOriginBadge';
import type { AdminAgentModelEntry, DiscoveredModel, AgentModelProvider } from '@reflex/shared';

export interface EffectiveDefaultDisplayProps {
  effectiveDefault: NonNullable<AdminAgentModelEntry['effectiveDefault']>;
  providers: AgentModelProvider[];
  discoveredModels: DiscoveredModel[];
}

export function EffectiveDefaultDisplay({
  effectiveDefault,
  providers,
  discoveredModels,
}: EffectiveDefaultDisplayProps) {
  if (effectiveDefault.origin === 'unset') {
    return null;
  }

  const { origin, modelId, providerId } = effectiveDefault;

  return (
    <div className="pt-4">
      <div className="rounded-md bg-muted/50 p-3" data-testid="effective-default-card">
        <div className="flex flex-wrap items-center justify-between gap-x-2 gap-y-1 mb-2">
          <SectionLabel as="span" className="text-xs">
            Current Agent Default
          </SectionLabel>
          <ModelDefaultOriginBadge origin={origin} />
        </div>
        <div className="flex flex-col gap-1.5 text-sm sm:flex-row sm:items-center sm:gap-3">
          <div className="flex shrink-0 items-center gap-1.5">
            <span className="shrink-0 text-muted-foreground">Provider:</span>
            <ProviderChip
              provider={providerId}
              name={providers.find((p) => p.id === providerId)?.displayName}
            />
          </div>
          <div className="flex min-w-0 items-center gap-1.5">
            <span className="shrink-0 text-muted-foreground">Model:</span>
            <ModelChip
              model={modelId}
              name={discoveredModels.find((m) => m.id === modelId)?.displayName}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
